import type React from 'react'
import { Reporter } from '../reporter/Reporter'

type props = { text?: string }

export const MagneticWeights: React.FC<props> = ({ text }) => (
  <div className={'affiliate'}>
    <Reporter
      text={text}
      defaultText={'Magnetic weights'}
      link="https://www.amazon.com/PlateMate-Microload-Pair-Magnetic-Weights/dp/B00078BOC8"
    />
  </div>
)
